module.exports = __webpack_public_path__ + "img/slider-people-4.c0790686.png";